import React from 'react';
import { Section, Title, Subtitle } from './Styled';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { theme } from '../theme';

const About: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.about[language];

  return (
    <Section id="about" bg={theme.colors.gray}>
      <Title style={{ color: theme.colors.green }}>{t.title}</Title>
      <Subtitle style={{ color: theme.colors.white }}>{t.description}</Subtitle>
      <ul style={{
        color: theme.colors.white,
        fontSize: '1.07rem',
        marginTop: '2rem',
        marginLeft: '1.5rem',
        lineHeight: 1.8,
        maxWidth: 600,
      }}>
        {t.bullets.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    </Section>
  );
};

export default About;
